export default class UserInfo {

    firstName;
    lastName;
    email;
    userId;
    allowColumnMenuSearchShipments;
    searchShipmentColumns;
    showCourierCustoms;
    showCourierTerms;
    showAirTrackingLink;
    showSeaTrackingLink;
    showShipmentBookings;
    showShipmentJobs;
    shipmentTimeFilter;

}
